'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { IconMinimap } from "@/templates/Heritage/utils/icons";

interface ToggleMapButtonProps {
    handleShowMapPopup?: () => void;
    dataMap?: any;
}

export default function ToggleMapButton({ handleShowMapPopup, dataMap }: ToggleMapButtonProps) {

    const t = useTranslations();
    const normalizedMaps = Array.isArray(dataMap)
        ? dataMap
        : (dataMap?.data && Array.isArray(dataMap.data) ? dataMap.data : []);
    const mapUrlRaw = normalizedMaps?.[0]?.url_map;
    let thumbnailUrl = mapUrlRaw;
    if (mapUrlRaw && !mapUrlRaw.includes('/v1/general/cmc/proxy-image')) {
        const urlToEncode = mapUrlRaw.startsWith('http') ? mapUrlRaw : `${window.location.origin}${mapUrlRaw.startsWith('/') ? '' : '/'}${mapUrlRaw}`;
        const apiBase = '/api/proxy';
        if (apiBase) {
            thumbnailUrl = `${apiBase}/v1/general/cmc/proxy-image?fileUrl=${encodeURIComponent(urlToEncode)}&w=256&q=80`;
        }
    }

    return (
        <>
            <div
                className="shadow-xl
    group
    fixed bottom-[100px] left-0 z-30
    h-[105px]
    w-[150px]
    bg-[var(--button-primary-bg-default)]
    flex items-center
    p-2
    overflow-hidden
    transition-transform duration-500 ease-in-out
    -translate-x-[108px]
    lg:hover:translate-x-0
    animate-fadeIn
    cursor-pointer
  "
                style={{
                    borderTopRightRadius: '20px',
                    borderBottomRightRadius: '20px',
                }}
                onClick={() => handleShowMapPopup?.()}
            >
                {/* MAP IMAGE */}
                <img
                    src={thumbnailUrl || ''}
                    alt=""
                    className="w-[100px] h-full object-cover rounded-md"
                />

                {/* TOGGLE ICON + TEXT */}
                <div className="absolute top-1/2 right-[-28px] -translate-y-1/2 flex items-center w-[105px] justify-center gap-1 cursor-pointer minimap-qtsc-toggle shrink-0 rotate-90">
                    <IconMinimap
                        stroke="var(--button-primary-label-default)"
                        className="w-5 h-5"
                    />

                    <span
                        className="
        text-[var(--button-primary-label-default)]
        text-sm
        
        whitespace-nowrap
      "
                    >
                        {t('MAP_TITLE')}
                    </span>
                </div>
            </div >


        </>
    );
}
